/**
 * authToken.js — Gestion centralisée du jeton d'accès API (JWT).
 *
 * Les endpoints backend sensibles (leads, emails, PDF) exigent désormais
 * un Bearer token. On accepte deux sources :
 *   - ts_api_token           : émis par /api/crm-auth/login (CRM + workflow)
 *   - thermasol_devisv2_jwt_v1 : émis par /api/devis-v2/login (pages Devis V2)
 *
 * Le CRM embarqué (crm-embed/index.html) écrit ts_api_token dans localStorage ;
 * comme il est servi sur la même origine que l'app React, le jeton est partagé.
 */

const API_TOKEN_KEY = "ts_api_token";
const DEVISV2_TOKEN_KEY = "thermasol_devisv2_jwt_v1";

export function getApiToken() {
  try {
    return (
      sessionStorage.getItem(API_TOKEN_KEY) ||
      localStorage.getItem(API_TOKEN_KEY) ||
      sessionStorage.getItem(DEVISV2_TOKEN_KEY) ||
      null
    );
  } catch {
    return null;
  }
}

export function setApiToken(token) {
  try {
    sessionStorage.setItem(API_TOKEN_KEY, token);
    localStorage.setItem(API_TOKEN_KEY, token);
  } catch {
    /* stockage indisponible */
  }
}

export function clearApiToken() {
  try {
    sessionStorage.removeItem(API_TOKEN_KEY);
    localStorage.removeItem(API_TOKEN_KEY);
  } catch {
    /* noop */
  }
}

/**
 * Retourne des en-têtes fusionnés incluant Authorization si un jeton existe.
 * @param {object} extra en-têtes additionnels
 */
export function authHeaders(extra = {}) {
  const token = getApiToken();
  return token ? { ...extra, Authorization: `Bearer ${token}` } : { ...extra };
}
